import styled from 'styled-components';

import React from 'react';
import { Link } from '@pb/shared/ui/atoms/link';

export const StyledAccountDetailItems = styled.ul`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100vh;
    margin: 0;
    padding: 0;
    list-style: none;
    background: ${({ theme }) => theme.color.white};

    @media (min-width: ${({ theme }) =>
            theme.deprecatedScreen.tabletLandscapeMinimum}) {
        position: absolute;
        top: auto;
        right: 0.4rem;
        left: auto;
        width: 24rem;
        height: initial;
        border: 0.1rem solid ${({ theme }) => theme.color.grey5};
        border-radius: ${({ theme }) => theme.borderRadius.default};
        box-shadow: ${({ theme }) => theme.shadow.middle};
    }
`;

export const StyledAccountDetailItem = styled.li`
    display: flex;
    flex-flow: row;
    align-items: center;
    min-height: 5.6rem;
    font-size: ${({ theme }) => theme.font.size.base};
    line-height: 2.4rem;
    letter-spacing: 0.005rem;
    border-bottom: 0.1rem solid ${({ theme }) => theme.color.grey4};
    cursor: pointer;

    && div {
        width: 100%;
    }

    && a,
    button {
        color: ${({ theme }) => theme.color.black};
        text-decoration: none;
    }

    && svg {
        margin-right: 1.6rem;
    }
`;

export const StyledLink = styled(properties => <Link {...properties} />)`
    && {
        display: block;
        width: 100%;

        > a,
        button {
            width: 100%;
            min-height: 5.6rem;
            padding: 0 1.6rem;
        }
    }
`;
